const Icon = ({ source, height = 25, width = 25, ...rest }) => (
    <img alt="Icon" src={source} height={height} width={width} {...rest} />
)

export default Icon;